import { usePostDetailsModalStore } from "../Modals/PostDetailsModal/PostDetailsModalStore";
import { useEffect } from "react";
import { PostDetailsPageActions } from "../Modals/PostDetailsModal/PostDetailsModal";

const getEnumValue = (action: string): PostDetailsPageActions | undefined => {
    for (const key in PostDetailsPageActions) {
        if (
            PostDetailsPageActions[
                key as keyof typeof PostDetailsPageActions
            ] === action
        ) {
            return PostDetailsPageActions[
                key as keyof typeof PostDetailsPageActions
            ];
        }
    }
    return undefined;
};

export function PostDetailsEntrypoint({
    postId,
    commentId,
    action,
}: {
    action: string;
    commentId: string;
    postId: string;
}) {
    const { setIsPostDetailsModalOpen, setPostDetailsAction } =
        usePostDetailsModalStore();
    useEffect(() => {
        const value = getEnumValue(action);
        value &&
            setPostDetailsAction({
                commentId,
                desiredAction: value,
            });
        setIsPostDetailsModalOpen(true, parseInt(postId));
    }, []);
    return <></>;
}
